import type { NamePath } from "antd/lib/form/interface";
import type { IntlShape } from "react-intl";

export const createMaxPlayersValidator = (
  getFieldValue: (name: NamePath) => any,
  formatMessage: IntlShape["formatMessage"],
  errorMsgKey: string,
) => ({
  validator(_: unknown, value: number) {
    if (!value || value <= getFieldValue("maximumRosterSize")) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(formatMessage({ id: errorMsgKey })));
  },
});
